import React from "react";
import Icon from "components/AppIcon";

export default function KPICard({ title, value, subtitle, icon, trend, trendValue, colorClass, bgClass, threshold }) {
  const isPositive = trendValue >= 0;
  return (
    <div className={`bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-4 lg:p-5 flex flex-col gap-3 shadow-sm`}>
      <div className="flex items-start justify-between gap-2">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${bgClass}`}>
          <Icon name={icon} size={20} color={colorClass} strokeWidth={2} />
        </div>
        {trendValue !== undefined && (
          <span className={`flex items-center gap-1 text-xs font-medium font-[var(--font-caption)] px-2 py-1 rounded-full ${isPositive ? "bg-emerald-50 text-emerald-600" : "bg-red-50 text-red-600"}`}>
            <Icon name={isPositive ? "TrendingUp" : "TrendingDown"} size={12} color={isPositive ? "#059669" : "#DC2626"} />
            {Math.abs(trendValue)}%
          </span>
        )}
      </div>
      <div>
        <p className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">{title}</p>
        <p className="text-xl lg:text-2xl font-bold font-[var(--font-heading)] text-[var(--color-foreground)] leading-tight">{value}</p>
        {subtitle && <p className="text-xs text-[var(--color-muted-foreground)] mt-1 font-[var(--font-caption)]">{subtitle}</p>}
      </div>
      {threshold !== undefined && (
        <div className="w-full bg-[var(--color-muted)] rounded-full h-1.5">
          <div
            className={`h-1.5 rounded-full transition-all duration-500 ${threshold >= 80 ? "bg-emerald-500" : threshold >= 60 ? "bg-amber-500" : "bg-red-500"}`}
            style={{ width: `${Math.min(threshold, 100)}%` }}
          />
        </div>
      )}
    </div>
  );
}